<template>
  <div class="w-full textColorDarkBlack orderDetail">
    <div class="member-content" v-if="orderData !== null">
      <!-- 訂單資訊 -->
      <div class="member-content-hd mb-4 text-NotoSansRegular px-4 borderColorDarkGray">
        <h2 class="mb-2 text-lg font-bold">※訂單資訊</h2>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">訂單編號：</span>
          {{ $route.params.id }}
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">訂購日期：</span>
          {{ orderData.created_at }}
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">訂單金額：</span>
          NT.{{ orderData.cart_info.total }}
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">訂單狀態：</span>
          <span v-if="orderData.status === 'created'" class="text-pinky">收到訂單</span>
          <span v-if="orderData.status === 'waiting'" class="text-pinky">等待付款</span>
          <span v-if="orderData.status === 'payment_fail'" class="text-pinky">付款失敗</span>
          <span v-if="orderData.status === 'paid'" class="text-pinky">完成付款</span>
          <span v-if="orderData.status === 'delivery'" class="text-pinky">配送中</span>
          <span v-if="orderData.status === 'finish'" class="text-pinky">訂單完成</span>
          <span v-if="orderData.status === 'invalid'" class="text-pinky">訂單取消</span>
          <span v-if="orderData.status === 'payment_warning'" class="text-pinky">訂單異常</span>
          <span v-if="orderData.status === 'payment_warning'" class="textColorRed text-xs"> (匯款金額不符，詳情請聯絡客服)</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">付款方式：</span>
          <span v-if="orderData.payment_info.type === 'CreditCard'">信用卡</span>
          <span v-if="orderData.payment_info.type === 'ATM'">ATM付款</span>
          <span v-if="orderData.payment_info.type === 'COD'">貨到付款</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4" v-if="orderData.delivery_info">
          <span class="font-bold">物流資訊：</span>
          <a v-if="orderData.delivery_info && orderData.delivery_info.name && orderData.delivery_info.track_no" target="_blank" :href="logisticsUrl(orderData.delivery_info)" class="underline">
            <span v-if="orderData.delivery_info.name">{{ deliveryName(orderData.delivery_info.name) }}</span>
            <span v-if="orderData.delivery_info.track_no"> / {{ orderData.delivery_info.track_no }}</span>
          </a>
          <span v-if="orderData.delivery_info.length === 0 && (((orderData.status === 'paid' || orderData.status === 'delivery' || orderData.status === 'finish') && orderData.payment_info.type !== 'COD') || ((orderData.status === 'created' || orderData.status === 'waiting') && orderData.payment_info.type === 'COD'))">物流處理中</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4" v-if="orderData.payment_info.type === 'ATM' && (orderData.status === 'created' || orderData.status === 'waiting') && orderData.payment_info.data.bankAccount">
          <span class="font-bold">轉帳資料：</span>
          <ul class="list-inside list-none pl-1 mt-1">
            <li>銀行名稱：{{ orderData.payment_info.data.bankName }}</li>
            <li>繳費銀行代碼：{{ orderData.payment_info.data.bankCode }}</li>
            <li>繳費虛擬帳號：{{ orderData.payment_info.data.bankAccount }}</li>
            <li>繳款期限：{{ moment(orderData.payment_info.data.expired_at).format('YYYY/MM/DD, HH:mm:ss') }}</li>
          </ul>
        </h3>
      </div>
      <!-- 發票資訊 -->
      <div class="member-content-hd mb-4 text-NotoSansRegular px-4 borderColorDarkGray">
        <h2 class="mb-2 text-lg font-bold">※發票資訊</h2>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">發票類型：</span>
          <span v-if="orderData.invoice_type === '紙本'">紙本-個人</span>
          <span v-if="orderData.invoice_type === '三聯式'">紙本-公司</span>
          <span v-if="orderData.invoice_type === '捐贈'">捐贈</span>
          <span v-if="orderData.invoice_type === '電子發票' && ((orderData.invoice_carrier_type === 1 && !orderData.tax_no && !orderData.tax_title) || (orderData.invoice_carrier_type === 2 && !orderData.tax_no && !orderData.tax_title) || (orderData.invoice_carrier_type === 3 && !orderData.tax_no && !orderData.tax_title))">電子發票-個人</span>
          <span v-if="orderData.invoice_type === '電子發票' && orderData.tax_no && orderData.tax_title">電子發票-公司</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">載具類別：</span>
          <span v-if="orderData.invoice_type === '紙本' || orderData.invoice_type === '捐贈'">無</span>
          <!-- 公司戶/純紙本 -->
          <span v-if="orderData.invoice_type === '電子發票' && !orderData.invoice_giving && orderData.invoice_send && orderData.tax_no && orderData.tax_title && !orderData.invoice_carrier">無</span>

          <span v-if="orderData.invoice_type === '電子發票' && orderData.invoice_carrier_type === 1 && !orderData.invoice_send">會員載具</span>
          <span v-if="orderData.invoice_type === '電子發票' && orderData.invoice_carrier_type === 2 && !orderData.invoice_send">自然人憑證條碼</span>
          <!-- 個人/手機條碼 -->
          <span v-if="orderData.invoice_type === '電子發票' && orderData.invoice_carrier_type === 3 && !orderData.tax_no && !orderData.tax_title && !orderData.invoice_send && orderData.invoice_carrier">手機條碼</span>
          <!-- 公司戶/手機條碼+紙本 -->
          <span v-if="orderData.invoice_type === '電子發票' && orderData.invoice_carrier_type === 3 && orderData.tax_no && orderData.tax_title && orderData.invoice_carrier">手機條碼</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">索取紙本發票：</span>
          <span v-if="orderData.invoice_type === '紙本' || orderData.invoice_type === '三聯式' || (orderData.invoice_type === '電子發票' && orderData.invoice_send && orderData.tax_no && orderData.tax_title && !orderData.invoice_giving)">是</span>
          <span v-else>無</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4" v-if="orderData.invoice_type === '三聯式' || (orderData.invoice_type === '電子發票' && orderData.tax_no && orderData.tax_title)">
          <span class="font-bold">發票抬頭：</span>
          <span>{{ orderData.tax_title }}</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4" v-if="orderData.invoice_type === '三聯式' || (orderData.invoice_type === '電子發票' && orderData.tax_no && orderData.tax_title)">
          <span class="font-bold">買方統編：</span>
          <span>{{ orderData.tax_no }}</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">發票日期：</span>
          <span v-if="orderData.invoice_date">{{ moment(orderData.invoice_date).format('YYYY/MM/DD') }}</span>
          <span v-else>---</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4">
          <span class="font-bold">發票號碼：</span>
          <span v-if="orderData.invoice_no">{{ orderData.invoice_no }}</span>
          <span v-else>---</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4" v-if="orderData.invoice_type === '電子發票'">
          <span class="font-bold">發票狀態：</span>
          <span v-if="orderData.invoice_status">{{ orderData.invoice_status }}</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4" v-if="orderData.invoice_type === '電子發票'">
          <span class="font-bold" v-if="orderData.invoice_carrier_type === 1 && !orderData.tax_no && !orderData.tax_title && !orderData.invoice_giving">中獎寄送地址：</span>
          <span class="font-bold" v-if="orderData.invoice_carrier_type === 2">自然人憑證：</span>
          <span class="font-bold" v-if="orderData.invoice_carrier_type === 3">手機條碼：</span>
          <span v-if="orderData.invoice_carrier && orderData.invoice_carrier_type !== 1">{{ orderData.invoice_carrier }}</span>
          <span v-if="orderData.invoice_carrier && orderData.invoice_carrier_type === 1 && !orderData.tax_no && !orderData.tax_title && !orderData.invoice_giving">{{ orderData.invoice_address }}</span>
        </h3>
        <h3 class="mb-2 text-sm lg:px-4" v-if="orderData.invoice_type === '捐贈' || (orderData.invoice_type === '電子發票' && !orderData.tax_no && !orderData.tax_title && orderData.invoice_giving)">
          <span class="font-bold">受贈機關或團體：</span>
          <span v-if="orderData.invoice_type === '電子發票'">{{ donationContent }}</span>
          <span v-else>001 財團法人基督教芥菜種會</span>
        </h3>
      </div>
      <div class="member-content-bd pb-5 text-NotoSansRegular px-4 md:px-0">
        <div class="section section-latest-order border-b borderColordarkgray">

          <table class="table-order w-full text-left" column="8">
            <thead class="text-sm">
              <tr class="bgLiveGray">
                <th class="sequence text-center">#</th>
                <th class="py-3 whitespace-no-wrap">商品名稱</th>
                <th class="py-3 md:text-center whitespace-no-wrap">數量</th>
                <th class="py-3 md:text-center whitespace-no-wrap">原價</th>
                <th class="py-3 md:text-center whitespace-no-wrap">折扣價</th>
                <th class="py-3 md:text-center whitespace-no-wrap">小計</th>
              </tr>
            </thead>
            <tbody class="text-sm">
              <tr v-for="(item, index) in orderData.cart_info.items" :key="index" class="md:border-b md:border-l md:border-r">
                <td class="sequence px-1 text-center">
                  0{{ index + 1 }}
                </td>
                <td>
                  <span class="mobileText whitespace-no-wrap">商品名稱：</span>
                  <p class="m-0 pl-2 md:pl-0" v-if="item.type === 'SUBSCRIPTION'">{{ item.link_name }}</p>
                  <p class="m-0 pl-2 md:pl-0">{{ item.name }}</p>

                  <p class="m-0 pl-2 md:pl-0" v-if="item.type === 'SUBSCRIPTION'">
                    <span>起訖：</span>
                    {{ moment(item.begin_at).format('YYYY/MM') }}~{{ moment(item.end_at).format('YYYY/MM') }}
                  </p>
                  <!-- 雜誌寄送 -->
                  <p v-if="orderData.cart_info.magazine_shipping_fee && (orderData.cart_info.magazine_shipping_fee> 0) && item.type === 'SUBSCRIPTION'" class="pl-2 md:pl-0">寄送：掛號</p>
                  <p v-if="!orderData.cart_info.magazine_shipping_fee && item.type === 'SUBSCRIPTION'" class="pl-2 md:pl-0">寄送：平信</p>
                  <!-- 贈品/搭售品 -->
                  <p class="text-pinky pl-2 md:pl-0" v-if="(item.selected_gifts && item.selected_gifts.length> 0) || (item.free_items && item.free_items.length)> 0">贈品/搭售品：</p>
                  <div v-if="item.selected_gifts && item.selected_gifts.length > 0" class="pl-3">
                    <p v-for="(child, idx) in item.selected_gifts" :key="idx" class="m-0 text-pinky" :class="{ 'line-through': child.out_of_stock }">
                      <span v-if="child.out_of_stock">(已贈完)</span><span>{{ child.name }}</span>
                    </p>
                  </div>
                  <div v-if="item.free_items && item.free_items.length> 0" class="pl-3">
                    <p v-for="(child, idx) in item.free_items" :key="idx" class="m-0 text-pinky" :class="{ 'line-through': child.out_of_stock }">
                      <span v-if="child.out_of_stock">(已贈完)</span><span>{{ child.name }}</span>
                    </p>
                  </div>
                </td>
                <td class="md:text-center">
                  <span class="mobileText">數量：</span>
                  {{ item.quantity }}
                </td>
                <td class="md:text-center">
                  <span class="mobileText">原價：</span>
                    {{ item.fixed_price }}
                </td>
                <td class="md:text-center">
                  <span class="mobileText">折扣價：</span>
                    {{ item.pricing }}
                </td>
                <td class="md:text-center">
                  <span class="mobileText">小計：</span>
                  {{ item.quantity*item.pricing }}
                </td>
              </tr>
              <tr v-for="(item) in orderData.cart_info.gifts" :key="item.id" class="md:border-b md:border-l md:border-r">
                <td class="sequence px-1 text-center">
                  (贈品/搭售品)
                </td>
                <td>
                  <span class="mobileText whitespace-no-wrap">商品名稱：</span>
                  <p class="m-0 pl-2 md:pl-0">
                    <span class="inline-block sm:hidden">(贈品/搭售品)</span>
                    {{ item.name }}
                    <span class="bgLiveBlack text-white px-1 ml-1" v-if="item.out_of_stock">已贈完</span>
                  </p>
                </td>
                <td class="md:text-center">
                  <span class="mobileText">數量：</span>
                1
                </td>
                <td class="md:text-center">
                  <span class="mobileText">原價：</span>
                    -
                </td>
                <td class="md:text-center">
                  <span class="mobileText">折扣價：</span>
                    -
                </td>
                <td class="md:text-center">
                  <span class="mobileText">小計：</span>
                  -
                </td>
              </tr>
              <tr class="text-sm border-0 mb-0" v-if="orderData.cart_info.events.length> 0">
                <td class="py-1 w-full" colspan="6">
                  <p class="leading-loose w-full" v-for="(item, index) in orderData.cart_info.events" :key="index">
                    <a :href="item.url" class="cursor-pointer">
                      <span class="bgLiveABCRed text-white px-1 mr-1" v-if="item.matched">活動</span>
                      <span class="textColorRed">{{ item.name }}</span>
                    </a>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="cart-bill py-6 flex justify-end px-4 borderColorDarkGray">
            <ul class="text-right text-sm">
              <li class="mb-1 lg:mb-2">
                <span class="inline-block font-bold">總金額</span>
                <span class="inline-block ml-1" style="min-width: 100px">{{ orderData.cart_info.subtotal }}</span>
              </li>

              <li class="mb-1 lg:mb-2">
                <span class="inline-block font-bold">活動折扣</span>
                <span class="inline-block ml-1" style="min-width: 100px">- {{ orderData.cart_info.discount }}</span>
              </li>
              <li class="mb-1 lg:mb-2">
                <span class="inline-block font-bold">訂單折扣</span>
                <span class="inline-block ml-1" style="min-width: 100px">- {{ orderData.cart_info.subtotal - orderData.cart_info.discount - Math.ceil((orderData.cart_info.subtotal - orderData.cart_info.discount) * (orderData.cart_info.percentage / 100)) }}</span>
              </li>
              <li class="mb-1 lg:mb-2">
                <span class="inline-block font-bold">運費</span>
                <span class="inline-block ml-1" style="min-width: 100px">+ {{ orderData.cart_info.shipping_fee }}</span>
              </li>
              <li class="mb-1 lg:mb-2" v-if="orderData.cart_info.magazine_shipping_fee && orderData.cart_info.magazine_shipping_fee> 0">
                <span class="inline-block font-bold">訂閱掛號運費</span>
                <span class="inline-block ml-1" style="min-width: 100px">+ {{ orderData.cart_info.magazine_shipping_fee }}</span>
              </li>
              <li class="last">
                <span class="inline-block font-bold">應付金額</span>
                <span class="inline-block ml-1" style="min-width: 100px">NT.{{ orderData.cart_info.total }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="section section-latest-order py-6 md:border-b px-4 borderColordarkgray borderColorDarkGray">
          <h2 class="mb-2 text-lg font-bold">※收件資訊</h2>
          <ul class="lg:px-8 lg:list-disc">
            <li class="mb-2 text-sm"><span class="font-bold">收件人：</span> {{ orderData.name }}</li>
            <li class="mb-2 text-sm"><span class="font-bold">連絡電話：</span> {{ orderData.country_code ? `(${orderData.country_code}) ` : null }}{{ orderData.mobile ? orderData.mobile : '' }} <span v-if="orderData.phone">/</span> {{ orderData.phone ? orderData.phone : '' }}</li>
            <li class="mb-2 text-sm"><span class="font-bold">配送地址：</span> {{ orderData.zip_code }}{{ orderData.city }}{{ orderData.district }}{{ orderData.address }}</li>
            <li class="mb-2 text-sm"><span class="font-bold">配送方式：</span> 宅配</li>
            <li class="mb-2 text-sm"><span class="font-bold">備註：</span> {{ orderData.remark }}</li>
          </ul>
        </div>
        <div class="flex justify-center w-full mt-4">
          <router-link class="cursor-pointer text-NotoSansRegular py-2 px-6 lg:py-1 lg:px-3 rounded text-sm addCartBtn block"
            type="button" :to="{ name: 'order' }">
            返回上一頁
          </router-link>
        </div>
      </div>

    </div>

    <div class="min-h-screen" v-else>
      <img src="~@/assets/icon/Pulse.gif" class="mx-auto h-12">
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  name: 'OrderDetail',
  data () {
    return {
      orderData: null,
      loveCode: null
    }
  },
  components: {
  },
  computed: {
    ...mapGetters([
      'userRole'
    ]),
    donationContent () {
      let self = this
      if (self.loveCode && self.orderData) {
        let counters = [...self.loveCode]
        let index = counters.findIndex(x => x.code === self.orderData.invoice_donation)
        return self.orderData.invoice_donation + ' ' + self.loveCode[index].name
      } else {
        return null
      }
    }
  },
  mounted () {
    this.getData()
    // this.swalOutStock()
  },
  updated () {
  },
  methods: {
    swalOutStock () {
      let self = this
      self.$swal({
        title: '贈品已贈送完畢',
        confirmButtonText: 'OK',
        confirmButtonColor: '#484848',
        width: 400,
        icon: 'info',
        customClass: {
          title: 'text-xl'
        }
      })
    },
    getData () {
      let self = this
      axios.get(`/orders/${self.$route.params.id}`)
        .then((response) => {
          self.orderData = response.data
          if (response.data.invoice_type === '電子發票' && !response.data.tax_no && !response.data.tax_title && response.data.invoice_giving) {
            self.getlovecode()
          }
        })
    },
    getlovecode () {
      let self = this
      axios.get('/cart/lovecode/list')
        .then((response) => {
          self.loveCode = Object.values(response.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    deliveryName (name) {
      if (name === 't-cat') {
        return '黑貓宅急便'
      } else if (name === 'post') {
        return '郵局'
      } else if (name === 'hct') {
        return '新竹物流'
      } else {
        return '宅配通'
      }
    },
    logisticsUrl (item) {
      if (item && item.name && item.track_no) {
        if (item.name === 't-cat') { // 黑貓
          return `https://www.t-cat.com.tw/inquire/TraceDetail.aspx?BillID=${item.track_no}`
        } else if (item.name === 'post') { // 郵局
          return `https://postserv.post.gov.tw/pstmail/main_mail.html?targetTxn=EB500100`
        } else if (item.name === 'hct') { // 新竹物流
          return `https://www.hct.com.tw/search/searchgoods_n.aspx`
        } else { // 宅配通
          return `https://www.e-can.com.tw/`
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.freegiftsTitle {
  opacity: 0;
}
.orderDetail {
  .addCartBtn {
    border: 1px solid #9c9c9c;
    transition: .3s;
    color: #434343;
    background-color: white;
    &:hover {
      color: white;
      background-color: #9c9c9c;
    }
  }

  .table-order td>.mobileText {
      display: none;
  }
  .table-order {
    thead {
      tr {
        th:first-child {
          width: 8%;
        }
        th:nth-child(2) {
          width: 40%;
        }
        th:nth-child(3), th:nth-child(4), th:nth-child(5), th:nth-child(6), th:nth-child(7) {
          width: 10%;
        }
      }
    }
    tbody {
      tr {
        td {
          padding: .8rem 0;
        }
      }
    }
  }
  @media (max-width: 640px) {
    .table-order thead tr:first-child {
        display: none;
    }
    .sequence {
      display: none !important;
    }
    .table-order, .table-order td, .table-order tr {
        display: block;
        text-align: left;
    }
    .table-order tbody tr {
        padding: 12px 0;
        font-size: 0;
    }
    .table-order tbody, .table-order td, .table-order tr {
        display: block;
        text-align: left;
    }
    .table-order td {
        width: 100%;
        display: inline-block;
        box-sizing: border-box;
        padding: 4px 6px 4px 6px !important;
        vertical-align: top;
        font-size: 14px;
    }
    .table-order tbody, .table-order td, .table-order tr {
        display: block;
        text-align: left;
    }
    .table-order td>.mobileText {
        display: inline-block;
    }
  }
}
</style>
